import { FEATURES } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListCustomViewsRequest extends IBaseRequest {
    limit?:           number;
    offset?:          number;
    orderBy?:         string;
    currentUserOnly?: boolean;
    FILTER?:          Filter;
    ORDER?:           Order;
}

export class ListCustomViewsRequest extends BaseRequest implements IListCustomViewsRequest {

  public limit?:           number;
  public offset?:          number;
  public orderBy?:         string;
  public currentUserOnly?: boolean;
  public FILTER?:          Filter;
  public ORDER?:           Order;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.limit = otherOptions.limit;
    this.offset = otherOptions.offset;
    this.orderBy = otherOptions.orderBy;
    this.currentUserOnly = otherOptions.currentUserOnly;
    this.FILTER = otherOptions.FILTER;
    this.ORDER = otherOptions.ORDER;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.currentUserOnly, 'currentUserOnly');
    if (this.FILTER) parameters += toFilterXml(this.FILTER);
    if (this.ORDER) parameters += toOrderXml(this.ORDER);

    return super.wrapperXml(FEATURES.listCustomViews, parameters);
  }
}
